import {
  axiosDeleteRequest,
  axiosGetRequest,
  axiosPostRequest,
  axiosPutRequest,
  getHealthPictureRoute,
  getReferenceRoute,
} from '../../api';
import { CreateDiagnosisDto, UpdateDiagnosisDto } from './dtos';
import { Diagnosis, DiagnosisSearchResult } from './models';

const getDiagnosesRoute = () => `${getHealthPictureRoute()}/diagnoses`;
const getSearchRoute = () => `${getReferenceRoute()}/diagnoses`;
const SEARCH_RESULTS_MAX = 20;

export const fetchDiagnosesCall = (journeyId: string) => {
  return axiosGetRequest<Diagnosis[]>(`${getDiagnosesRoute()}/${journeyId}`);
};

export const searchDiagnosesCall = (searchString: string) => {
  const encodedSearchString = encodeURIComponent(searchString);
  return axiosGetRequest<DiagnosisSearchResult[]>(
    `${getSearchRoute()}/${encodedSearchString}/${SEARCH_RESULTS_MAX}`
  );
};

export const insertDiagnosesCall = (diagnoses: CreateDiagnosisDto[]) => {
  return axiosPostRequest<CreateDiagnosisDto[], Diagnosis[]>(
    `${getDiagnosesRoute()}`,
    diagnoses
  );
};

export const updateDiagnosisCall = (diagnosis: UpdateDiagnosisDto) => {
  return axiosPutRequest<UpdateDiagnosisDto, Diagnosis>(
    `${getDiagnosesRoute()}`,
    diagnosis
  );
};

export const deleteDiagnosisCall = (diagnosisId: string) => {
  return axiosDeleteRequest<string, void>(
    `${getDiagnosesRoute()}/${diagnosisId}`
  );
};
